import Breadcrumb from "../components/Breadcrumb";
import ContactHero from "../components/Contact/ContactHero";

const Contact = () => {
  return (
    <div>
      <Breadcrumb curPage={"Contact"} />
      <ContactHero />
    </div>
  );
};

export default Contact;
